import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DateRange {
  startDate: string;
  endDate: string;
}

interface DashboardState {
  selectedDateRange: DateRange;
  refreshInterval: number;
  sidebarCollapsed: boolean;

  // Actions
  setDateRange: (range: DateRange) => void;
  setRefreshInterval: (interval: number) => void;
  toggleSidebar: () => void;
}

const today = new Date();
const thirtyDaysAgo = new Date(today);
thirtyDaysAgo.setDate(today.getDate() - 30);

const formatDate = (date: Date) => date.toISOString().split('T')[0];

export const useDashboardStore = create<DashboardState>()(
  persist(
    (set) => ({
      selectedDateRange: {
        startDate: formatDate(thirtyDaysAgo),
        endDate: formatDate(today),
      },
      refreshInterval: 60000, // 1 minute
      sidebarCollapsed: false,

      setDateRange: (range) => set({ selectedDateRange: range }),
      setRefreshInterval: (interval) => set({ refreshInterval: interval }),
      toggleSidebar: () =>
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
    }),
    {
      name: 'dashboard-storage',
    }
  )
);
